module.exports = {
  idaman: {
    // Client HYROC-Dev terdaftar di IDAMAN utama (bukan QA).
    OIDC_AUTHORITY: 'https://login.idaman.pertamina.com',
    OIDC_CLIENT_ID: 'ebef97e7367544fea9fd6dcb6117c6ef',
    OIDC_CLIENT_SCR: 'a49e1b81-471d-472a-91d1-ca395585bca5',
    // Redirect URI harus mengikuti origin tempat aplikasi dijalankan.
    // Jika di-hard-code ke satu host (mis. Azure dev), login yang dimulai
    // dari host lain (localhost) akan gagal di callback: state OIDC
    // disimpan di sessionStorage tab asal, sehingga signinRedirectCallback()
    // throw "No matching state found in storage" dan user dilempar balik
    // ke /login. Env var REACT_APP_OIDC_REDIRECT_URI tetap dihormati bila
    // di-set (mis. untuk produksi dengan domain tetap).
    OIDC_REDIRECT_URI:
      process.env.REACT_APP_OIDC_REDIRECT_URI ||
      `${window.location.origin}/signin-oidc`,
    OIDC_LOGOUT_URI:
      process.env.REACT_APP_OIDC_LOGOUT_URI ||
      `${window.location.origin}/signout-callback-oidc`,
  },
  google: {
    API_KEY: '',
    CLIENT_ID: '',
    SECRET: '',
  },
  facebook: {
    APP_ID: '',
  },
  web: {
    WEB_URL: 'https://hydrofedev.azurewebsites.net',
  },
  api: {
    // Local BE: BE/hydro-be (profil Local, http://localhost:5167).
    // Dev PTM: 'https://hydroapidev.azurewebsites.net/api'
    API_URL: 'https://hydroapidev.azurewebsites.net/api',
  },
  download: {
    DWL_URL:
      'https://hydroapidev.azurewebsites.net/api/docs/supporting-documents/',
  },
  // `06.WebApi` (ProHydro) — master data: Fungsi, Klausa Category/Information,
  // Jenis Pengadaan, Crude Category, RefineryUnits (the reports' Plant lookup).
  proHydro: {
    API_URL:
      'https://hydroapicrudejoindev-dqedg3dca2h4enak.indonesiacentral-01.azurewebsites.net',
  },
  // `06.WebApi.Crude` — ChangeRequest approval workflow, CDU, Evaluation
  // Document, Reception Facility, Data Tracking, all four Reports.
  crude: {
    API_URL:
      'https://hydrowebapicrudejoindev-dddhftbycqfycyez.indonesiacentral-01.azurewebsites.net',
  },
  // Saklar halaman Pengumuman Tender publik. Data berasal dari api/public/tender-announcement.
  // true  = `/` menampilkan halaman Pengumuman Tender tanpa login.
  // false = seluruh landing publik mati; `/` kembali ke perilaku lama (ke /login).
  publicLanding: {
    ENABLED: true,
  },
};

module.hardcodeparam = {
  procurement: {
    PRODUCT_ID: '',
    PRODUCTYPE_PROPANE_ID: '',
    SECRET: '',
  },
};
